import React, { useState, useEffect, useContext, useRef } from "react";
import { Form, Formik, Field } from "formik";
import { useHistory } from "react-router-dom";
import DayPicker from "react-day-picker";
import * as yup from "yup";

import Subtitle from "components/SubTitle";
import Row from "components/Grid/Row";
import Col from "components/Grid/Col";
import Button from "components/Button";
import CheckBox from "components/Form/CheckBox";
import Label from "components/Form/Label";

import Mask from "utils/src/mask";
import { GlobalAuthContext, GlobalLoaderContext, GlobalOperationContext } from "store/context";
import Colors from "constants/Colors";
import { FitinsurAPI, MessageCenter } from "utils";
import FitFormTolls from "utils/src/fitinsur-form-tolls";
import Crypt from "utils/src/crypt";

import {
  Container,
  Content,
  ButtonContainer,
  Fieldset,
  Heading,
  CalendarContainer,
  AdvisoryText,
  Head,
  Subtitle2,
  Title,
  Logo,
  Line,
} from "./styles";

export default function QuoteADD(props) {
  const MONTHS = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
  ];
  const WEEKDAYS_LONG = [
    "Segunda-Feira",
    "Terça-Feira",
    "Quarta-Feira",
    "Quinta-Feira",
    "Sexta-Feira",
    "Sábado",
    "Domingo",
  ];
  const WEEKDAYS_SHORT = ["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SÁB"];
  const [questions, setQuestions] = useState([]);
  const [limits, setlimits] = useState([]);
  const [validations, setValidations] = useState({});
  const [showCalendar, setShowCalendar] = useState(false);
  const [statusOperation, setStatusOperation] = useState(null);
  const [searchList] = useState([]);

  const { idProduct } = props.match.params;
  const formikRef = useRef(Formik);
  const history = useHistory();
  const fitinsurAPI = new FitinsurAPI();
  const mc = new MessageCenter();
  const fitForm = new FitFormTolls();
  const crypt = new Crypt();

  const authContext = useContext(GlobalAuthContext);
  const operationContext = useContext(GlobalOperationContext);
  const loading = useContext(GlobalLoaderContext);
  const initialValues = {
    218: "",
    219: "",
    220: "",
    221: "",
    222: "",
    223: "",
    224: "",
    225: "",
    226: "",
    227: "",
    230: "",
    233: "",
    205: "",
    206: "",
    207: "",
    208: "",
    209: "",
    210: "",
    211: "",
    212: "",
    213: "",
    214: "",
    215: "",
    216: "",
    217: "",
    232: "",
    confirmData: false,
  };

  // constante com ids e descrição dos campos do formulário
  const fieldQuestions = {
    typeInsurance: '218',
    typeRisk: '219',
    annualGrossRevenue: '220',
    lawSuit: '221',
    claimsTotal: '222',
    latestComplaints: '223',
    damageCaused: '224',
    complainantFullName: '225',
    effectiveDate: '226',
    retroactivity: '227',
    limitsPF: '230',
    limitesPJ: '233',
    CPFCNPJ: '205',
    email: '206',
    fullName: '207',
    birthDate: '208',
    cellPhone: '209',
    cep: '210',
    street: '211',
    number: '212',
    complement: '213',
    city: '214',
    state: '215',
    CRO: '216',
    politicallyExposed: '217',
    personType: '232'
  };

  const requestQuestions = async () => {
    loading.start();
    fitinsurAPI.setAuthToken(authContext.token);
    fitinsurAPI
      .requestAddAction(18, null)
      .then((x) => x.json())
      .then((response) => {
        if (response.ret_code != 200) {
          mc.error(response.ret_msg_details);
          loading.stop();
          return;
        }
        const mergeQuestions = [
          ...questions,
          ...response.ret_value.riskQuestionnaire,
          ...response.ret_value.personQuestionnaire,
          ...response.ret_value.operationQuestionnaire,
        ];
        setQuestions(mergeQuestions);
        /* Limites pessoa física descontinuado 
        let limPF = response.ret_value.riskQuestionnaire.find(
          (question) => question.idQuestion === 230
        ); 
        */
        /* let limPJ = response.ret_value.riskQuestionnaire.filter(
          (question) => question.idQuestion === 233
        );

        setlimits(limPJ); */

        operationContext.add_response = response.ret_value;
        localStorage.setItem("fitOperation", JSON.stringify(operationContext));
        if (props?.match?.params?.idOperation)
          return requestGetQuoteFormatted();

        return loading.stop();
      })
      .catch((e) => {
        console.log(e);
        loading.stop();
      });
  };

  async function requestGetQuoteFormatted() {
    console.log("requestGetQuoteFormatted - BEGIN");
    loading.start();
    fitinsurAPI.setAuthToken(authContext.token);
    fitinsurAPI
      .requestGetQuote(idProduct, props?.match?.params?.idOperation)
      .then((x) => x.json())
      .then(async (response) => {
        console.log("requestGetQuoteFormatted - requestGetQuote - BEGIN");
        if (response.ret_code != 200) {
          mc.error(response.ret_msg_details);
          return loading.stop();
        }
        const { ret_value } = response;
        console.log("requestGetQuoteFormatted - requestGetQuote - getUniqObjBeetweenSames");
        const getUniqObjBeetweenSames = (array) =>
          array
            .map((item) => ({
              answer: item.answer,
              idQuestion: item.idQuestion,
              questionDescription: item.dsQuestion,
              questionDomain: item.idDomainQuestion,
              answerOptions: item.answerOptions,
              idAnswerOption: item.idAnswerOption
            }))
            .filter(
              (item, pos, self) =>
                self.findIndex(
                  (v) =>
                    v.answer === item.answer &&
                    item.idQuestion == v.idQuestion
                ) === pos
            );

        console.log("requestGetQuoteFormatted - requestGetQuote - risks");
        const risks = getUniqObjBeetweenSames(ret_value.risks);
        console.log("requestGetQuoteFormatted - requestGetQuote - operations");
        const operations = getUniqObjBeetweenSames(ret_value.operations);
        console.log("requestGetQuoteFormatted - requestGetQuote - persons");
        const persons = getUniqObjBeetweenSames(ret_value.persons);

        const chosenLimits = risks.filter(
          ({ idQuestion }) => idQuestion == 233
        ).map(item => ({ dsAnswerOption: item.answer, idAnswerOption: item.idAnswerOption }));

        // Agrupando todas as responstas no mesmo array
        const answeredQuestions = ([...risks, ...operations, ...persons]);

        Object.keys(initialValues).map((idQuestion) => {
          formikRef.current.setFieldValue(idQuestion, findAnswer(idQuestion, answeredQuestions));
        });

        formikRef.current.setFieldValue(fieldQuestions.limitesPJ, chosenLimits);

        // Definindo o tipo de person e limites
        //handlePersonType(formikRef.current.values[fieldQuestions.personType]);

        setStatusOperation(ret_value.operation.idDomainStatus);
        console.log("requestGetQuoteFormatted - requestGetQuote - END");
        loading.stop();
      })
      .catch((e) => {
        loading.stop();
        mc.error(e.message);
        console.log(e);
      });
  };

  const findAnswer = (findIdQuestion, array) => {
    const question = array.find((item) => item.idQuestion == findIdQuestion);
    if (!question) {
      return;
    };

    if (question.questionDomain == 43 || question.questionDomain == 44) {
      const chosen = array.filter(({ idQuestion }) => idQuestion == findIdQuestion);
      const result = question.answerOptions.filter(
        (objFromA) => chosen.find(
          (objFromB) => objFromA.dsAnswerOption == objFromB.answer
        )
      );

      if (!result || result.length < 1) {
        return "";
      }

      const answerOption = {
        idAnswerOption: (result[0].idAnswerOption),
        dsAnswerOption: (result[0].dsAnswerOption)
      };

      return answerOption;
    }

    const answer = array.find(question => question.idQuestion == String(findIdQuestion)).answer;
    return answer;
  };

  function handleSelect(field) {
    formikRef.current.values[field] === true ? formikRef.current.setFieldValue(field, false)
      : formikRef.current.setFieldValue(field, true);
  }

  const fieldErrorMessage = (event) => {
    let question = event.path.length > 3
      ? event.path.split('.')[1]
      : event.path;

    formikRef.current.isSubmitting && mc.error(`Campo: ${fitForm.getDsQuestion(question, questions)} é Obrigatório`);
    return "* Campo Obrigatório"
  };

  const getvalidationSchema = async () => {

    let val = yup.object().shape({
      218: fitForm.verifyRequired(fieldQuestions.typeInsurance, questions)
        ? yup.string().required(fieldErrorMessage)
        : yup.string().notRequired(),
      219: fitForm.verifyRequired(fieldQuestions.typeRisk, questions)
        ? yup.string().required(fieldErrorMessage)
        : yup.string().notRequired(),
      220: (fitForm.verifyRequired(fieldQuestions.annualGrossRevenue, questions) &&
        formikRef.current.values[`${fieldQuestions.personType}`].idAnswerOption === 2532)
        ? yup.string().required(fieldErrorMessage)
        : yup.string().notRequired(),
      221: fitForm.verifyRequired(fieldQuestions.lawSuit, questions)
        ? yup.string().required(fieldErrorMessage)
        : yup.string().notRequired(),
      222: fitForm.verifyRequired(fieldQuestions.claimsTotal, questions)
        ? yup.string().required(fieldErrorMessage)
        : yup.string().notRequired(),
      223: fitForm.verifyRequired(fieldQuestions.latestComplaints, questions)
        ? yup.string().required(fieldErrorMessage)
        : yup.string().notRequired(),
      224: fitForm.verifyRequired(fieldQuestions.damageCaused, questions)
        ? yup.string().required(fieldErrorMessage)
        : yup.string().notRequired(),
      225: fitForm.verifyRequired(fieldQuestions.complainantFullName, questions)
        ? yup.string().required(fieldErrorMessage)
        : yup.string().notRequired(),
      226: fitForm.verifyRequired(fieldQuestions.effectiveDate, questions)
        ? yup.string().required(fieldErrorMessage)
        : yup.string().notRequired(),
      227: fitForm.verifyRequired(fieldQuestions.retroactivity, questions)
        ? yup.string().required(fieldErrorMessage)
        : yup.string().notRequired(),
      230: fitForm.verifyRequired(fieldQuestions.limitsPF, questions)
        ? yup.string().required(fieldErrorMessage)
        : yup.string().notRequired(),
      233: fitForm.verifyRequired(fieldQuestions.limitesPJ, questions)
        ? yup.string().required(fieldErrorMessage)
        : yup.string().notRequired(),
      205: fitForm.verifyRequired(fieldQuestions.CPFCNPJ, questions)
        ? yup.string().required(fieldErrorMessage)
        : yup.string().notRequired(),
      206: fitForm.verifyRequired(fieldQuestions.email, questions)
        ? yup.string().required(fieldErrorMessage).email("Email Inválido")
        : yup.string().notRequired(),
      207: fitForm.verifyRequired(fieldQuestions.fullName, questions)
        ? yup.string().required(fieldErrorMessage)
        : yup.string().notRequired(),
      232: fitForm.verifyRequired(fieldQuestions.personType, questions)
        ? yup.string().required(fieldErrorMessage)
        : yup.string().notRequired(),
      216: fitForm.verifyRequired(fieldQuestions.CRO, questions)
        ? yup.string().required(fieldErrorMessage)
        : yup.string().notRequired(),
      //confirmData: yup.boolean().oneOf([true], fieldErrorMessage),
    });
    setValidations(val);
  };

  const handleSubmit = (values) => {
    if (values["confirmData"] === false) {
      mc.error("É necessário confirmar a veracidade das informações fornecidas.");
      return;
    };

    loading.start();
    if (values[`${fieldQuestions.personType}`].idAnswerOption === 2532) {
      const value = Mask.numbers(values[`${fieldQuestions.CPFCNPJ}`]);
      if (value.length < 14) {
        mc.error('Número CNPJ Inválido');
        formikRef.current.setFieldError(fieldQuestions.CPFCNPJ, "CNPJ Inválido");
        loading.stop();
        return;
      }
    };

    let body = {
      idOperation: props?.match?.params?.idOperation,
      OptionDeduct: [],
      OptionMaxLim: [],
      add_step: 2,
      coverageListSelected: "",
      firstInstallmentDate: "",
      idDomainPerson: 34, // ToDo pegar dinamico
      idPlanCoverage: null,
      idRiskAnswer: [],
      idRiskQuestion: [],
      id_person: 0, // ToDo pegar dinamico
      id_product: idProduct,
      id_product_list: [],
      legalPersonId: null,
      operationQuestionnaire: [],
      paymentMethod: "",
      paymentMode: "",
      paymentQuestionnaire: [],
      personFirstName: null, // ToDo pegar dinamico
      personLastName: null, // ToDo pegar dinamico
      personQuestionnaire: [],
      riskIdQuestionnaire: null,
      riskQuestionnaire: [],
      textRiskAnswer: [],
    };

    let qstRisk = [];
    let qstOperation = [];
    let qstPerson = [];

    // Montando os questionários
    Object.keys(values).map((idQuestion) => {
      const item = questions.find(
        (item) => item.idQuestion.toString() === idQuestion
      );
      if (!item) return;
      let qst = {
        idAnswerOption: Array.isArray(values[idQuestion])
          ? values[idQuestion].map((option) => option.idAnswerOption.toString())
          : values[idQuestion].idAnswerOption
            ? values[idQuestion].idAnswerOption?.toString() :
            null,
        idDomainPersonRole: item.idDomainPersonRole,
        idQuestion: Number(idQuestion),
        idQuestionnaire: item.idQuestionnaire,
        questionDomain: item.questionDomain,
        textQuestionAnswer: Array.isArray(values[idQuestion])
          ? values[idQuestion].map((answer) => answer.dsAnswerOption)
          : values[idQuestion].dsAnswerOption
            ? values[idQuestion].dsAnswerOption
            : values[idQuestion],
      };

      if (item.idQuestionnaire === 28) {
        // person questionarie
        // CPF/CNPJ only number
        if (qst.idQuestion === 205) {
          let unformated = Mask.numbers(qst.textQuestionAnswer);
          qst.textQuestionAnswer = unformated;
        }
        qstPerson.push(qst);
        return;
      }
      if (item.idQuestionnaire === 29) {
        // risk questionarie
        qstRisk.push(qst);
        return;
      }
      if (item.idQuestionnaire === 22) {
        // operation questionarie
        qstOperation.push(qst);
        return;
      }
    });

    body.riskQuestionnaire = qstRisk;
    body.personQuestionnaire = qstPerson;
    body.operationQuestionnaire = qstOperation;

    console.log("Body -> ", body);

    fitinsurAPI.setAuthToken(authContext.token);
    fitinsurAPI
      .requestAddAction2(body)
      .then((response) => response.json())
      .then((data) => {
        loading.stop();
        if (Array.isArray(data)) {
          if (data[5].acceptResultFinal === false) {
            mc.error('Sem planos disponíveis no momento para esse perfil. Entre em contato com Comercial da AIO.');
            return;
          };

          if (data[8].ret_code && data[8].ret_code === 200) {
            mc.success(`Cotação ${data[1].id_operation} criada com sucesso`);
            history.push({
              pathname: `/embed/aio/plans/${idProduct}/${data[1].id_operation}`,
              state: { idOperation: data[1].id_operation, personRole: data[0] },
            });
          }
          loading.stop();
          return;
        };

        if (data.ret_code && data.ret_code === 200) {
          return history.push({
            pathname: `/embed/aio/plans/${idProduct}/${props?.match?.params?.idOperation}`,
          });
        };

        if (data.ret_code && data.ret_code !== 200) {
          console.log("Erro ->", JSON.stringify(data));
          mc.error(`${data?.ret_msg ? data?.ret_msg : data?.ret_message}`);

          loading.stop();
          return;
        };
      })
      .catch((e) => {
        loading.stop();
        console.log(e);
      });
  };

  const getSearch = (fieldId, params) => {
    const question = questions.find(
      (item) => item.idQuestion.toString() === fieldId
    );
    let behaviors = JSON.parse(question.questionBehavior);
    let unformated = null;

    if (fieldId === "205") {
      unformated = Mask.numbers(params);
      formikRef.current.values[`${fieldQuestions.personType}`].idAnswerOption === 2531 //CPF
        ? searchSerproCpf(unformated)
        : searchSerproCnpj(unformated);
      return;
    }

    if (behaviors && !!behaviors.isSearchField) {

      fitinsurAPI.setAuthToken(authContext.token);
      fitinsurAPI
        .requestQueryAction(
          behaviors.searchQueryId,
          unformated ? unformated : params
        )
        .then((response) => response.json())
        .then((data) => {
          if (data.ret_code !== 200) {
            mc.error("Erro durante a Consulta");
            return;
          }
          formikRef.current.setFieldValue(
            fieldQuestions.fullName,
            data.ret_value[0].PERSON_NAME
          );
        })
        .catch((err) => console.log(err));
      return;
    }
    return;
  };

  const searchSerproCnpj = (searchValue) => {
    fitinsurAPI.setAuthToken(authContext.token);
    fitinsurAPI.requestSerproCnpj(Mask.numbers(searchValue))
      .then(response => response.json())
      .then(data => {
        if (data.ret_code !== 200) {
          data.ret_value.trim() === "Nenhum registro encontrado."
            ? mc.error(`${data.ret_value}`)
            : mc.error("Erro durante a Consulta do CNPJ")
          return "";
        }
        formikRef.current.setFieldValue(fieldQuestions.fullName, data?.ret_value?.nomeEmpresarial);
        return;
      })
      .catch((err) => {
        mc.error(`"Erro durante a Consulta do CNPJ"`);
      });
  }

  const searchSerproCpf = (searchValue) => {
    fitinsurAPI.setAuthToken(authContext.token);
    fitinsurAPI.requestSerproCpf(Mask.numbers(searchValue))
      .then(response => response.json())
      .then(data => {
        if (data.ret_code !== 200) {
          data.ret_value.trim() === "Nenhum registro encontrado."
            ? mc.error(`${data.ret_value}`)
            : mc.error("Erro durante a Consulta do CPF")
          return "";
        }
        formikRef.current.setFieldValue(fieldQuestions.fullName, data?.ret_value?.nome);
        return;
      })
      .catch((err) => {
        mc.error(`"Erro durante a Consulta do CPF"`);
      });
  }

  const handlePersonType = async (value) => {

    formikRef.current.setFieldValue(fieldQuestions.personType, value);

    let lim = fitForm.verifyOptions(fieldQuestions.limitesPJ, questions);

    // Limpando campo CPFCNPJ para o user redigitar...
    formikRef.current.setFieldValue(fieldQuestions.CPFCNPJ, "")
    formikRef.current.setFieldValue(fieldQuestions.fullName, "")
    switch (value.idAnswerOption) {

      case 2531:
        //PF
        const limPF = lim.map(item => item.value).filter(element => element.idAnswerOption !== 2538);
        formikRef.current.setFieldValue(fieldQuestions.limitesPJ, limPF);
        // BUGFIX Limpando seleção do campo caso haja alteração da personType
        formikRef.current.setFieldValue(fieldQuestions.annualGrossRevenue, "");
        setlimits(() => limPF)
        break;
        ;

      case 2532:
        //PJ  
        const limPJ = lim.map(item => item.value).filter(element => element.idAnswerOption !== 2533);
        formikRef.current.setFieldValue(fieldQuestions.limitesPJ, limPJ);
        setlimits(() => limPJ)
        break;
        ;

      default:
        break;
    };
  };

  useEffect(() => {
    getvalidationSchema();
  }, [questions, limits]);

  useEffect(() => {
    function getToken() {
      loading.start();
      // limpa localStorage
      const resetOperation = {
        add2_request: {},
        add2_response: {},
        add_response: {},
        issue_request: [],
        issue_response: [],
      };
      Object.assign(operationContext, resetOperation)
      localStorage.clear();

      //#################################################################################
      // 20220801 - valida user via URL com userid base64
      //#################################################################################
      //const user = process.env.REACT_APP_USER_AIO;
      //const password = process.env.REACT_APP_PUBLIC_APP_PASSWORD_AIO;
      let params = new URLSearchParams(props?.location?.search);
      let user, password, user_encoded;
      try {
        user_encoded = Buffer.from(params.get("userid"), "base64").toString("ascii");
      } catch (err) {
        console.log("Erro ao acessar o sistema");
        mc.error("Erro ao acessar o sistema");
        loading.stop();
        return;
      }
      if (user_encoded == process.env.REACT_APP_USER_AIO) {
        user = process.env.REACT_APP_USER_AIO;
        password = process.env.REACT_APP_PUBLIC_APP_PASSWORD_AIO;
      }
      if (user_encoded == process.env.REACT_APP_USER_AIO_DENTALIS) {
        user = process.env.REACT_APP_USER_AIO_DENTALIS;
        password = process.env.REACT_APP_PUBLIC_APP_PASSWORD_AIO_DENTALIS;
      }
      if (!user) {
        console.error("Erro ao acessar o sistema");
        mc.error("Erro ao acessar o sistema");
        loading.stop();
        return;
      }
      //#################################################################################

      fitinsurAPI.requestLogin(user, password)
        .then(data => data.json())
        .then(response => {
          console.log("requestLogin - Success:", response);
          authContext.login_response = response;
          if (response.ret_code == "200") {
            authContext.status = true;
            //authContext.username = process.env.REACT_APP_USER_AIO;
            if (response.ret_token) authContext.token = response.ret_token; // LEGACY LOGIN
            if (response.ret_value.token)
              authContext.token = response.ret_value.token; // LOGIN V2
            authContext.person_product = response.ret_person_product;
            authContext.region = response.ret_value.region;
            authContext.enumProfile = response.ret_value.enumProfile;
            authContext.firstLogin = false;
            authContext.username = response.ret_value.username;
            if (response.ret_value) {
              authContext.firstLogin = Number(response.ret_value.loginCount) <= 0;
            }

            // armazena contexto-token logado no storage
            localStorage.setItem("session", crypt.encryptJson(authContext));
            console.log("authContext", authContext);
            fitinsurAPI.setAuthToken(response.ret_value.token);
            requestQuestions();
          } else {
            authContext.status = false;
            authContext.username = "";
            authContext.token = "";
            authContext.person_product = [];
            authContext.user_region = "";
            console.log("Erro ao acessar o sistema");
            mc.error("Erro ao acessar o sistema");
          };
        })
        .catch((error) => {
          authContext.status = false;
          authContext.username = "";
          authContext.token = "";
          authContext.person_product = [];
          authContext.user_region = "";
          authContext.login_response = "ERROR: " + error.message;
          console.error("requestLogin - Error:", error);
          console.log("Erro ao acessar o sistema");
          mc.error("Erro ao acessar o sistema");
          //router.push('/embed/ops');
        })
        .finally(() => {
          loading.stop();
        });
    };

    if (authContext.status && props?.match?.params?.idOperation) {
      requestQuestions();
    } else {
      getToken();
    }
  }, []);


  return (
    <Container>
      <Head>
        <Row>
          <Col className="d-sm-none" style={{ display: "flex", justifyContent: "center", marginBottom: "10px" }}>
            <Logo user={authContext.username}></Logo>
          </Col>
          <Col sm={12}>
            <Title>Nova Cotação</Title>
            <Subtitle2>RESPONSABILIDADE CIVIL PROFISSIONAL DENTISTAS</Subtitle2>
          </Col>
        </Row>
        <Logo user={authContext.username} className="d-none d-sm-block p-0 p-md-2"></Logo>
      </Head>

      <Subtitle
        idProduct={idProduct}
        idOperation={props?.match?.params?.idOperation}
        statusOperation={statusOperation}
        stage={1}
        activeColor={Colors.PRIMARY}
      />
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        //enableReinitialize={true}
        validationSchema={validations}
        onSubmit={(values) => handleSubmit(values)}
      >
        {(formikprops) => (
          <Form>
            <Content>
              <Head>
                <Heading>Dados do Segurado</Heading>
                <AdvisoryText>
                  *Campos marcados com * são obrigatórios
                </AdvisoryText>
              </Head>
              <Fieldset>
                <Row>
                  <Col sm={12} xs={12} md={12} style={{ alignSelf: "flex-end" }} hidden={fitForm.verifyVisiblity(fieldQuestions.personType, questions)}>
                    <Field
                      name={fieldQuestions.personType}
                      label={fitForm.getDsQuestion(fieldQuestions.personType, questions)}
                      component={fitForm.verifyComponent(fieldQuestions.personType, questions)}
                      options={fitForm.verifyOptions(fieldQuestions.personType, questions)}
                      value={formikprops.values[`${fieldQuestions.personType}`]}
                      onChange={(value) => {
                        handlePersonType(value);
                      }}
                      isRequired={fitForm.verifyRequired(fieldQuestions.personType, questions)}
                      row
                    />
                  </Col>
                </Row>
                <Row style={{ marginTop: "20px" }}>
                  <Col sm={12} xs={12} md={6} style={{ alignSelf: "flex-end" }} hidden={fitForm.verifyVisiblity(fieldQuestions.CPFCNPJ, questions)}>
                    <Field
                      name={fieldQuestions.CPFCNPJ}
                      label={fitForm.getDsQuestion(fieldQuestions.CPFCNPJ, questions)}
                      component={fitForm.verifyComponent(fieldQuestions.CPFCNPJ, questions)}
                      options={fitForm.verifyOptions(fieldQuestions.CPFCNPJ, questions)}
                      rightIconClick={() =>
                        getSearch(fieldQuestions.CPFCNPJ, formikprops.values[`${fieldQuestions.CPFCNPJ}`])
                      }
                      value={formikprops.values[`${fieldQuestions.personType}`].idAnswerOption === 2531
                        ? Mask.cpf(formikprops.values[`${fieldQuestions.CPFCNPJ}`])
                        : Mask.cnpj(formikprops.values[`${fieldQuestions.CPFCNPJ}`])
                      }
                      searchList={searchList}
                      onChange={(value) => {
                        formikprops.values[`${fieldQuestions.personType}`].idAnswerOption === 2531
                          ? formikprops.setFieldValue(fieldQuestions.CPFCNPJ, Mask.cpf(value))
                          : formikprops.setFieldValue(fieldQuestions.CPFCNPJ, Mask.cnpj(value))
                      }}
                      isRequired={fitForm.verifyRequired(fieldQuestions.CPFCNPJ, questions)}
                    />
                  </Col>
                  <Col sm={12} xs={12} md={6} style={{ alignSelf: "flex-end" }} hidden={fitForm.verifyVisiblity(fieldQuestions.CRO, questions)}>
                    <Field
                      name={fieldQuestions.CRO}
                      label={fitForm.getDsQuestion(fieldQuestions.CRO, questions)}
                      component={fitForm.verifyComponent(fieldQuestions.CRO, questions)}
                      options={fitForm.verifyOptions(fieldQuestions.CRO, questions)}
                      value={
                        formikprops.values[`${fieldQuestions.CRO}`]
                      }
                      isRequired={fitForm.verifyRequired(fieldQuestions.CRO, questions)}
                    />
                  </Col>
                </Row>
                <Row style={{ marginTop: "20px" }}>
                  <Col sm={12} xs={12} md={6} style={{ alignSelf: "flex-end" }} hidden={fitForm.verifyVisiblity(fieldQuestions.fullName, questions)}>
                    <Field
                      name={fieldQuestions.fullName}
                      label={fitForm.getDsQuestion(fieldQuestions.fullName, questions)}
                      component={fitForm.verifyComponent(fieldQuestions.fullName, questions)}
                      options={fitForm.verifyOptions(fieldQuestions.fullName, questions)}
                      isRequired={fitForm.verifyRequired(fieldQuestions.fullName, questions)}
                      readOnly ={formikprops.values[`${fieldQuestions.personType}`].idAnswerOption !== 2531}
                      disabled ={formikprops.values[`${fieldQuestions.personType}`].idAnswerOption !== 2531}
                    />
                  </Col>
                  <Col style={{ alignSelf: "flex-end" }} hidden={fitForm.verifyVisiblity(fieldQuestions.email, questions)}>
                    <Field
                      name={fieldQuestions.email}
                      label={fitForm.getDsQuestion(fieldQuestions.email, questions)}
                      component={fitForm.verifyComponent(fieldQuestions.email, questions)}
                      options={fitForm.verifyOptions(fieldQuestions.email, questions)}
                      isRequired={fitForm.verifyRequired(fieldQuestions.email, questions)}
                    />
                  </Col>
                  <Line />
                </Row>
              </Fieldset>

              <Head>
                <Heading>Questionario de Risco</Heading>
              </Head>
              <Fieldset>
                {!fitForm.verifyVisiblity(fieldQuestions.typeInsurance) &&
                  (
                    <Row>
                      <Col style={{ alignSelf: "flex-end" }}
                        md={6}
                        sm={6}
                        hidden={fitForm.verifyVisiblity(fieldQuestions.typeInsurance, questions)}
                      >
                        <Field
                          name={fieldQuestions.typeInsurance}
                          label={fitForm.getDsQuestion(fieldQuestions.typeInsurance, questions)}
                          component={fitForm.verifyComponent(fieldQuestions.typeInsurance, questions)}
                          options={fitForm.verifyOptions(fieldQuestions.typeInsurance, questions)}
                          onChange={(value) => formikprops.setFieldValue(fieldQuestions.typeInsurance, value)}
                          isRequired={fitForm.verifyRequired(fieldQuestions.typeInsurance, questions)}
                        />
                      </Col>
                    </Row>
                  )}
                <Row style={{ marginTop: "20px" }}>
                  <Col style={{ alignSelf: "flex-end" }}
                    hidden={fitForm.verifyVisiblity(
                      fieldQuestions.typeRisk,
                      questions
                    )}
                  >
                    <Field
                      isRequired={fitForm.verifyRequired(fieldQuestions.typeRisk, questions)}
                      name={fieldQuestions.typeRisk}
                      key={fieldQuestions.typeRisk}
                      label={fitForm.getDsQuestion(
                        fieldQuestions.typeRisk,
                        questions
                      )}
                      component={fitForm.verifyComponent(
                        fieldQuestions.typeRisk,
                        questions
                      )}
                      value={
                        formikprops.values[fieldQuestions.typeRisk]
                      }
                      options={fitForm.verifyOptions(
                        fieldQuestions.typeRisk,
                        questions
                      )}
                      onChange={(value) => {
                        formikprops.setFieldValue(
                          fieldQuestions.typeRisk,
                          value
                        );
                      }}
                    />
                  </Col>
                </Row>
                <Row style={{ marginTop: "20px" }}>
                  <Col style={{ alignSelf: "flex-end" }}
                    hidden={fitForm.verifyVisiblity(
                      fieldQuestions.annualGrossRevenue,
                      questions
                    ) || formikprops.values[`${fieldQuestions.personType}`].idAnswerOption === 2531}
                  >
                    <Field
                      isRequired={fitForm.verifyRequired(fieldQuestions.annualGrossRevenue, questions)}
                      name={fieldQuestions.annualGrossRevenue}
                      key={fieldQuestions.annualGrossRevenue}
                      label={fitForm.getDsQuestion(
                        fieldQuestions.annualGrossRevenue,
                        questions
                      )}
                      component={fitForm.verifyComponent(
                        fieldQuestions.annualGrossRevenue,
                        questions
                      )}
                      value={
                        formikprops.values[fieldQuestions.annualGrossRevenue]
                      }
                      options={fitForm.verifyOptions(
                        fieldQuestions.annualGrossRevenue,
                        questions
                      )}
                      onChange={(value) => {
                        formikprops.setFieldValue(
                          fieldQuestions.annualGrossRevenue,
                          value
                        );
                      }}
                    />
                  </Col>
                </Row>

                <Row style={{ marginTop: "20px" }}>
                  <Col style={{ alignSelf: "flex-end" }}
                    hidden={fitForm.verifyVisiblity(fieldQuestions.lawSuit, questions)}
                  >
                    <Field
                      isRequired={fitForm.verifyRequired(fieldQuestions.lawSuit, questions)}
                      name={fieldQuestions.lawSuit}
                      key={fieldQuestions.lawSuit}
                      label={fitForm.getDsQuestion(fieldQuestions.lawSuit, questions)}
                      component={fitForm.verifyComponent(
                        fieldQuestions.lawSuit,
                        questions
                      )}
                      value={
                        formikprops.values[fieldQuestions.lawSuit]
                      }
                      options={fitForm.verifyOptions(fieldQuestions.lawSuit, questions)}
                      onChange={(value) =>
                        formikprops.setFieldValue(
                          fieldQuestions.lawSuit,
                          value
                        )
                      }
                      tabIndex={fieldQuestions.lawSuit}
                      tooltip="O segurado tem conhecimento de qualquer fato ou circunstância que possa gerar uma reclamação extrajudicial, processo judicial civil, criminal ou ético administrativo ou de qualquer tipo similar de pedido de reparação de dano(s) causado(s) pela prestação de seus serviços?"
                      tooltipColor="#01AEAA"
                      tooltipIcon="question"
                      row
                    />
                  </Col>
                </Row>

                <Row style={{ marginTop: "20px" }}>
                  <Col style={{ alignSelf: "flex-end" }} hidden={fitForm.verifyVisiblity(fieldQuestions.claimsTotal) || formikprops.values[fieldQuestions.lawSuit].idAnswerOption === 2509}>

                    <Field
                      isRequired={fitForm.verifyRequired(fieldQuestions.claimsTotal, questions)}
                      name={fieldQuestions.claimsTotal}
                      key={fieldQuestions.claimsTotal}
                      label={fitForm.getDsQuestion(fieldQuestions.claimsTotal, questions)}
                      component={fitForm.verifyComponent(fieldQuestions.claimsTotal, questions)}
                      value={formikprops.values[fieldQuestions.claimsTotal]}
                      options={fitForm.verifyOptions(fieldQuestions.claimsTotal, questions)}
                      onChange={(value) =>
                        formikprops.setFieldValue(
                          fieldQuestions.claimsTotal,
                          value
                        )
                      }
                      tabIndex={fieldQuestions.claimsTotal}
                      row
                    />
                  </Col>
                </Row>

                <Row style={{ marginTop: "20px" }}>
                  <Col style={{ alignSelf: "flex-end" }} hidden={fitForm.verifyVisiblity(fieldQuestions.latestComplaints, questions) || formikprops.values[fieldQuestions.lawSuit].idAnswerOption === 2509}>

                    <Field
                      isRequired={fitForm.verifyRequired(fieldQuestions.latestComplaints, questions)}
                      name={fieldQuestions.latestComplaints}
                      key={fieldQuestions.latestComplaints}
                      label={fitForm.getDsQuestion(fieldQuestions.latestComplaints, questions)}
                      component={fitForm.verifyComponent(fieldQuestions.latestComplaints, questions)}
                      value={formikprops.values[fieldQuestions.latestComplaints]}
                      options={fitForm.verifyOptions(fieldQuestions.latestComplaints, questions)}
                      onChange={(value) =>
                        formikprops.setFieldValue(
                          fieldQuestions.latestComplaints,
                          value
                        )
                      }
                      tabIndex={fieldQuestions.latestComplaints}
                      row
                    />
                  </Col>
                </Row>

                <Row style={{ marginTop: "20px" }}>
                  <Col style={{ alignSelf: "flex-end" }} hidden={fitForm.verifyVisiblity(fieldQuestions.damageCaused, questions)}>
                    <Field
                      isRequired={fitForm.verifyRequired(fieldQuestions.damageCaused, questions)}
                      name={fieldQuestions.damageCaused}
                      key={fieldQuestions.damageCaused}
                      label={fitForm.getDsQuestion(fieldQuestions.damageCaused, questions)}
                      component={fitForm.verifyComponent(fieldQuestions.damageCaused, questions)}
                      value={formikprops.values[fieldQuestions.damageCaused]}
                      options={fitForm.verifyOptions(fieldQuestions.damageCaused, questions)}
                      onChange={(value) =>
                        formikprops.setFieldValue(
                          fieldQuestions.damageCaused,
                          value
                        )
                      }
                      tabIndex={fieldQuestions.damageCaused}
                      row
                    />
                  </Col>
                </Row>

                <Row style={{ marginTop: "20px" }}>
                  <Col style={{ alignSelf: "flex-end" }}
                    hidden={fitForm.verifyVisiblity(
                      fieldQuestions.complainantFullName
                    ) || formikprops.values[fieldQuestions.damageCaused].idAnswerOption === 2517}
                  >
                    <Field
                      isRequired={fitForm.verifyRequired(fieldQuestions.complainantFullName, questions)}
                      name={fieldQuestions.complainantFullName}
                      key={fieldQuestions.complainantFullName}
                      label={fitForm.getDsQuestion(
                        fieldQuestions.complainantFullName,
                        questions
                      )}
                      component={fitForm.verifyComponent(
                        fieldQuestions.complainantFullName,
                        questions
                      )}
                      value={
                        formikprops.values[fieldQuestions.complainantFullName]
                      }
                      options={fitForm.verifyOptions(
                        fieldQuestions.complainantFullName,
                        questions
                      )}
                      onChange={(value) => {
                        formikprops.setFieldValue(
                          fieldQuestions.complainantFullName,
                          value
                        );
                      }}
                    />
                  </Col>
                </Row>

                <Row style={{ marginTop: "20px" }}>
                  <Col sm={12} xs={12} md={6} style={{ alignSelf: "flex-end" }} hidden={fitForm.verifyVisiblity(fieldQuestions.effectiveDate)}>
                    <a href="#calendarAnchor" style={{ textDecoration: "none", color: "inherit" }}>
                      <Field
                        isRequired={fitForm.verifyRequired(fieldQuestions.effectiveDate, questions)}
                        name={fieldQuestions.effectiveDate}
                        label={fitForm.getDsQuestion(fieldQuestions.effectiveDate, questions)}
                        component={fitForm.verifyComponent(fieldQuestions.effectiveDate, questions)}
                        options={fitForm.verifyOptions(fieldQuestions.effectiveDate, questions)}
                        rightIcon="calendar"
                        rightIconClick={() => setShowCalendar(!showCalendar)}
                        type="text"
                        readOnly
                      />
                    </a>
                    {showCalendar && (
                      <CalendarContainer>
                        <DayPicker
                          style
                          disabledDays={[
                            {
                              before: new Date(),
                            },
                          ]}
                          months={MONTHS}
                          weekdaysLong={WEEKDAYS_LONG}
                          weekdaysShort={WEEKDAYS_SHORT}
                          firstDayOfWeek={0}
                          fixedWeeks
                          onDayClick={(t, { disabled }) => {
                            if (disabled) return
                            formikprops.setFieldValue(
                              fieldQuestions.effectiveDate,
                              new Date(t).toLocaleDateString("en-GB")
                            );
                            setShowCalendar(false);
                          }}
                        />
                      </CalendarContainer>
                    )}
                  </Col>

                  <Col sm={12} xs={12} md={6} style={{ alignSelf: "flex-end" }} hidden={fitForm.verifyVisiblity(fieldQuestions.retroactivity, questions)}>
                    <Field
                      isRequired={fitForm.verifyRequired(fieldQuestions.retroactivity, questions)}
                      name={fieldQuestions.retroactivity}
                      label={fitForm.getDsQuestion(fieldQuestions.retroactivity, questions)}
                      component={fitForm.verifyComponent(fieldQuestions.retroactivity, questions)}
                      options={fitForm.verifyOptions(fieldQuestions.retroactivity, questions)}
                      tooltip="A retroatividade serve para ampliar o escopo de cobertura do produto,
                       fazendo com que o segurado tenha uma segurança maior em serviços prestados anteriormente.
                       Lembrando que a retroatividade só é aplicada para fatos desconhecidos pelo segurado. 
                       No caso de sinistro faremos a solicitação da apólice anterior para comprovação da 
                       retroatividade caso seja renovação de congênere (outra Seguradora)."
                      tooltipIcon="question"
                      tooltipColor="#01AEAA"
                    />
                  </Col>
                </Row>

                <Row style={{ marginBottom: "10px", marginTop: "20px" }}>
                  <Col sm={12} md={12} lg={12}>
                    <Field name="confirmData">
                      {({ field, form, meta }) => (
                        <Label meta={{ ...meta, error: !formikprops.values.confirmData, touched: !formikprops.values.confirmData }}>
                          <CheckBox
                            value={formikprops.values.confirmData}
                            checked={formikprops.values.confirmData}
                            onChange={() => handleSelect('confirmData')}
                          />
                          Estou ciente que as perguntas acima são referentes ao risco do segurado e serão utilizadas na análise, precificação e aceitação do risco. Portanto, a seguradora assume que todas as respostas fornecidas acima são verídicas. Caso seja constatado que alguma informação fornecida não corresponda com a realidade do risco, fica entendido e concordado que a cobertura do seguro ficará prejudicada, podendo inclusive ser declinada.
                        </Label>
                      )}
                    </Field>
                  </Col>
                </Row>
              </Fieldset>
            </Content>
            <ButtonContainer>
              <Button
                primary
                type="submit"
              >
                CONTINUAR
              </Button>
            </ButtonContainer>
          </Form>
        )}
      </Formik>
      <a name="calendarAnchor"></a>
    </Container>
  );
}
